import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';

@Component({
  selector: 'app-death-registration-details-modal',
  standalone: false,
  templateUrl: './death-registration-details-modal.component.html',
  styleUrl: './death-registration-details-modal.component.scss'
})
export class DeathRegistrationDetailsModalComponent{

form: FormGroup;
isQueryingApplication: boolean;
isApprovingApplication: boolean;

constructor(
  private dialog: MatDialog,
  public dialogRef: MatDialogRef<DeathRegistrationDetailsModalComponent>,
  @Inject(MAT_DIALOG_DATA) public dialogData: any,
  private apiService: ApiService,
  private formBuilder: FormBuilder,
  private authService: AuthService
) { }

ngOnInit(): void {

  this.initializeForm();

  this.patchForm(this.dialogData)
}

initializeForm() {
  this.form = this.formBuilder.group({
      surname: [''],
      firstName: [''],
      middleName: [''],
      gender: [''],
      address: [''],
      dod: [''],
      typeOfDeath: [''],
      placeOfDeath: [''],
      timeOfDeath: [''],
      proofOfDeath: [''],
      deceasedMeansOfId: [''],

      relationAsin: [''],
      relationSurname: [''],
      relationFirstName: [''],
      relationMiddleName: [''],
      relationPhoneNumber: [''],
      relationAddress: [''],
      relationship: [''],
      relationMeansOfId: [''],
  });
}

closeModal(): void {

    this.dialogRef.close();

}

hasAccess(permissions: string[]) {
  return this.authService.hasAnyPermission(permissions)
}

patchForm(data: any) {

  this.form.patchValue({

    surname: data.lastName || '',
    firstName: data.firstName || '',
    middleName: data.middleName || '',
    gender: data.gender || '',
    address: data.address || '',
    dod: data.dod || '',
    typeOfDeath: data.typeOfDeath || '',
    placeOfDeath: data.placeOfDeath || '',
    timeOfDeath: data.timeOfDeath || '',
    proofOfDeath: data.proofOfDeath || '',
    deceasedMeansOfId: data.deceasedMeansOfId || '',

    relationAsin: data.relationAsin || '',
    relationSurname: data.relationSurname || '',
    relationFirstName: data.relationFirstName || '',
    relationMiddleName: data.relationMiddleName || '',
    relationPhoneNumber: data.relationPhoneNumber || '',
    relationAddress: data.relationAddress || '',
    relationship: data.relationship || '',
    relationMeansOfId: data.relationMeansOfId || '',
  });


  this.form.disable();
}


openErrorModal(message: string) {
  let dialogRef = this.dialog.open(ErrorModalComponent, {
    width: '350px',
    backdropClass: 'modal-form-backdrop',
    hasBackdrop: true,
    panelClass: ['modal-form'],
    data: { errorMessage: message },
  });

  dialogRef.afterClosed().subscribe(() => { });
}

openSuccessModal(message: string) {
  let dialogRef = this.dialog.open(SuccessModalComponent, {
    width: '350px',
    backdropClass: 'modal-form-backdrop',
    hasBackdrop: true,
    panelClass: ['modal-form'],
    data: { successMessage: message },
  });

  dialogRef.afterClosed().subscribe(() => {
    this.dialogRef.close({reload: true});
  });
}

queryApplication() {
  const formValues = this.form.value;

  this.openConfirmationModal({
    title: 'Are you sure you want to decline this application?',
    onConfirm: () => {

      this.isQueryingApplication = true;

      this.apiService.post('/workflow/get-next-approving-officer', {
        entityId: this.dialogData?.id,
        workflowName: 'DEATH_REGISTRATION',
        type: 'QUERIED'
      }).pipe(
        finalize(() => {
          this.isQueryingApplication = false;
        })
      ).subscribe((res) => {
        if (res.success) {
          this.openSuccessModal(res.message || 'Application queried successfully')
        }
        else {
          this.openErrorModal(res?.error || res?.message);

        }
      },
        (error) => {
          this.openErrorModal(error || 'Unable to decline application');
        })
    },
    onCancel: () => console.log('Declined action cancelled'),
  });
}

openConfirmationModal({
  title,
  onConfirm,
  onCancel = () => { },
}: {
  title: string;
  onConfirm: () => void;
  onCancel?: () => void;
}) {
  this.dialog.open(ConfirmActionComponent, {
    width: '400px',
    backdropClass: 'modal-form-backdrop',
    hasBackdrop: true,
    panelClass: ['modal-form', 'modal-no-overflow-changed'],
    disableClose: true,
    data: {
      title,
      body: '',
      confirmText: 'Yes',
      lottieIconPath: 'assets/lottie/alert.json',
      onConfirm,
      onCancel,
      showCancelButton: true,
      showConfirmButton: true,
    },
  });
}
approveApplication() {
  this.openConfirmationModal({
    title: 'Are you sure you want to approve this application?',
    onConfirm: () => {
      this.isApprovingApplication = true;



      this.apiService.post('/workflow/get-next-approving-officer', {
        entityId: this.dialogData?.id,
        workflowName: 'DEATH_REGISTRATION',
        type: 'APPROVED'
      }).pipe(
        finalize(() => {
          this.isApprovingApplication = false;
        })
      ).subscribe((res) => {
        if (res.success) {
          this.openSuccessModal(res.message)
        }
        else {
          this.openErrorModal(res?.error || res?.message);

        }
      },
        (error) => {
          this.openErrorModal(error || 'Unable to approve application');
        })
    },
    onCancel: () => console.log('Approval action cancelled'),
  });
}


}
